import Device from "baseStyles/enums/device";
import { SuiStylesType, useSuiStyles } from "baseStyles/useSuiStyles";
import { FlexBoxPropsType } from "schoolUiComponents/basic/Box/FlexBox/types";
import { InputPropsType } from "schoolUiComponents/basic/Input/types";

type PropsType = {}

type StylesType = {
    mainBox: FlexBoxPropsType;
    footerStyle: FlexBoxPropsType;
    footerContentStyle: FlexBoxPropsType;
}

const Styles: SuiStylesType<PropsType, StylesType> = {
    [Device.types.Desktop]: ({theme}) => {
        return {
            mainBox: {
                width: 421,
                gap: 24
            },
            footerStyle: {
                padding: 32,
                height: 156,
            },
            footerContentStyle: {
            }
        }
    },
    [Device.types.Tablet]: (props) => {
        return {
            mainBox: {
                width: 400,
            },
            footerStyle: {
                padding: 24,
                height: 156,
            },
            footerContentStyle: {
            }
        }
    },
    [Device.types.Mobile]: (props) => {
        return {
            mainBox: {
                width: 327,
                margin: "32px 24px auto 24px"
            },
            footerStyle: {
                margin: "24px 0 0 0",
                padding: 24,
                height: 'auto'
            },
            footerContentStyle: {
                column: true
            }
        }
    }
}

const SignupStyles = useSuiStyles(Styles);

export default SignupStyles;